import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { OracleCloudStorageLinkedService } from 'app/model/linkedservice/oracle-cloud-storage.linkedservice';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import {
    parameterizableSecretBaseToModel,
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableTextOrAKVtoValue,
    parameterizableValueToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleCloudStorageLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                serviceUrl: '*',
                accessKeyId: 'akv',
                secretAccessKey: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class OracleCloudStorageLinkedServiceAdapter extends LinkedServiceAdapter<OracleCloudStorageLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => OracleCloudStorageLinkedService {
        return OracleCloudStorageLinkedService;
    }

    protected model(): IModel {
        return OracleCloudStorageLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: OracleCloudStorageLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.OracleCloudStorageLinkedService;

        properties.type = Metamodel.modelFor(OracleCloudStorageLinkedService).name;
        properties.typeProperties = {
            serviceUrl: this.valueToResource(linkedService, OracleCloudStorageLinkedService.SERVICE_URL),
            accessKeyId: parameterizableTextOrAKVtoValue(linkedService, OracleCloudStorageLinkedService.ACCESS_KEY_ID, this.context),
            secretAccessKey: parameterizablePasswordOrAKVtoSecretBase(linkedService, OracleCloudStorageLinkedService.ACCESS_KEY, this.context)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: OracleCloudStorageLinkedService): Promise<OracleCloudStorageLinkedService> {
        const properties = linkedServiceResource.properties as Model.OracleCloudStorageLinkedService;
        ValueAdapter.toModel(linkedService, OracleCloudStorageLinkedService.SERVICE_URL, properties.typeProperties.serviceUrl);
        parameterizableValueToModel(linkedService, OracleCloudStorageLinkedService.ACCESS_KEY_ID, properties.typeProperties.accessKeyId, this.context);
        parameterizableSecretBaseToModel(linkedService, OracleCloudStorageLinkedService.ACCESS_KEY, properties.typeProperties.secretAccessKey, this.context);

        return linkedService;
    }
}
